import  { UserPermission } from './userpermission';
import  { UserNotification } from './usernotification';
import  { UserRole } from './userrole';
import  { SocialSiteType } from './socialsitetype';

export class AuthUser {

        public static readonly className:string = "com.tanzeel.common.vo.AuthUserVO";

        constructor(){}

        id: number;
        userId: string;
        password: string;
        userRoleId: number;
        userRole: UserRole;
        socialSiteType: SocialSiteType;
        socialUniqueId: string;
        resetPswdLink: string;
        resetPswdExpiry: any;
        resetPassword: boolean;
        resetCard: boolean;
        childUser: boolean;
        derivedName: string;
        teacherDisplayName?: string | null;
        derivedId: number;
        active: boolean;
        lastLoggedInTime: any;
        delete: boolean;

}
